import { CLICK_EVENT, HIDE_CSS_CLASS } from '../JobFilter/constants';

export default class StickyFilterBtn {
    constructor(elm, args) {
        this.elm = elm;
        this.changeDisplayBtnNode = elm.querySelector(
            '[data-change-display-btn]',
        );
        this.gitterSpanNode =
            this?.changeDisplayBtnNode?.querySelector('.gitter');
        this.listSpanNode = this?.changeDisplayBtnNode?.querySelector('.list');
        this.filterBtnNode = elm.querySelector('[data-display-filter-btn]');
        this.filterBadgeNumberNode = this?.filterBtnNode?.querySelector(
            '[data-filter-badge]',
        );

        if (args?.initialFilterBadgeNumber) {
            this.updateFilterBadgeNumber(args.initialFilterBadgeNumber);
        }

        if (args?.onClickFilter) {
            this?.filterBtnNode?.addEventListener(
                CLICK_EVENT,
                args.onClickFilter,
            );
        }

        if (args?.onClickChangeDisplay) {
            this?.changeDisplayBtnNode?.addEventListener(
                CLICK_EVENT,
                function () {
                    args?.onClickChangeDisplay();
                    this.toggleJobTypeDisplay();
                }.bind(this),
            );
        }
    }

    toggleJobTypeDisplay() {
        this.gitterSpanNode.classList.toggle(HIDE_CSS_CLASS);
        this.listSpanNode.classList.toggle(HIDE_CSS_CLASS);
    }

    updateFilterBadgeNumber(number) {
        this.filterBadgeNumberNode.innerText = number;
        const isHidden =
            this.filterBadgeNumberNode.classList.contains(HIDE_CSS_CLASS);
        if (number > 0) {
            isHidden &&
                this.filterBadgeNumberNode.classList.remove(HIDE_CSS_CLASS);
        } else {
            !isHidden &&
                this.filterBadgeNumberNode.classList.add(HIDE_CSS_CLASS);
        }
    }
}
